/** @format */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import expressLogo from "../assets/express-logo.svg";
import redisLogo from "../assets/redis.jpg";
import reactnativeLogo from "../assets/reactnative.png";

const Resume = () => {
  return (
    <article className="resume active" data-page="resume">
      <header className="flex">
        <h2 className="h2 article-title">Resume</h2>
      </header>

      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <FontAwesomeIcon icon={faBookOpen} />
          </div>
          <h3 className="h3">Experience</h3>
        </div>

        <ol className="timeline-list">
          <li className="timeline-item">
            <h4 className="h4 timeline-item-title">
              Senior Full Stack Developer
            </h4>
            <div className="flex timeline-job item-center">
              <a
                className="h4"
                href="https://www.highbridgegroup.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Highbridge Group |
              </a>
              <span className="mx-2 my-1 text-sm">May 2025 - Present</span>
            </div>
            <p className="timeline-text">
              Architected and built the company's core MERN stack platform from
              scratch, including user/admin dashboards, authentication, email
              automation, and a custom PDF generation engine.
            </p>
            <p className="timeline-text">
              Developed an employee attendance tracking system with facial photo
              verification, clock-in/out features, and real-time monitoring
              while optimizing overall app performance.
            </p>
            <p className="timeline-text">
              Led the technical architecture and development of the entire
              platform, ensuring scalability, security, and optimal performance.
            </p>
          </li>
          <li className="timeline-item">
            <h4 className="h4 timeline-item-title">
              Mid-Level Full-Stack Developer
            </h4>
            <div className="flex timeline-job item-center">
              <a
                className="h4"
                href="https://rns.id/"
                target="_blank"
                rel="noopener noreferrer"
              >
                RNS GLOBAL |
              </a>
              <span className="mx-2 my-1 text-sm">April 2022 - Sep 2024</span>
            </div>
            <p className="timeline-text">
              Engineered Web3 decentralized applications (dApps) and user
              interfaces focused on blockchain transactions.
            </p>
            <p className="timeline-text">
              Contributed across full-stack Agile sprints, implementing
              cryptographic security protocols and refactoring legacy code to
              significantly reduce technical debt and boost performance.
            </p>
            <p className="timeline-text">
              Collaborated with cross-functional teams to deliver high-quality
              features and improve overall system architecture.
            </p>
          </li>
          <li className="timeline-item">
            <h4 className="h4 timeline-item-title">
              Junior Full-Stack Developer
            </h4>
            <div className="flex timeline-job item-center">
              <a
                className="h4"
                href="https://www.pentalog.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                PENTALOG |
              </a>
              <span className="mx-2 my-1 text-sm">Jan 2021 - Feb 2022</span>
            </div>
            <p className="timeline-text">
              Contributed to full-cycle web development using Node.js, Express,
              and React.
            </p>
            <p className="timeline-text">
              Optimized database query performance, participated in active code
              reviews, and collaborated with international teams to deliver
              high-quality features.
            </p>
            <p className="timeline-text">
              Implemented best practices in code quality, testing, and
              deployment processes.
            </p>
          </li>

          <li className="timeline-item">
            <h4 className="h4 timeline-item-title">
              Freelance Full Stack Developer
            </h4>

            <div className="flex timeline-job item-center">
              <a
                className="h4"
                href="https://www.upwork.com/freelancers/~01914ae9b035146f76"
                target="_blank"
                rel="noopener noreferrer"
              >
                Upwork |
              </a>
              <span className="mx-2 my-1 text-sm">2021 - Present</span>
            </div>

            <p className="timeline-text">
              Offering full-stack web development services and building
              independent projects using modern web technologies.
            </p>

            <p className="timeline-text">
              Managing development workflows, version control, deployment, and
              continuous skill development.
            </p>
          </li>
        </ol>
      </section>

      {/* Education Section */}
      <section className="timeline">
        <div className="title-wrapper">
          <div className="icon-box">
            <FontAwesomeIcon icon={faBookOpen} />
          </div>
          <h3 className="h3">Education</h3>
        </div>

        <ol className="timeline-list">
          <li className="timeline-item">
            <h4 className="h4 timeline-item-title">
              Federal University of Agriculture, Abeokuta (FUNAAB), Nigeria
            </h4>
            <span>2014 - 2019</span>
            <p className="timeline-text">
              Bachelor of Engineering in Electrical and Electronics Engineering
            </p>
          </li>
          <li className="timeline-item">
            <h4 className="h4 timeline-item-title">
              Fantasy global academy, Nigeria
            </h4>
            <span>October 2017</span>
            <p className="timeline-text">Software design and Communications</p>
          </li>
        </ol>
      </section>

      {/* Skills Section */}
      <section className="skill">
        <h3 className="h3 skills-title">My Tools</h3>
        <ul className="skills-list content-card">
          {/* Languages */}
          <li className="skills-item">
            <div className="title-wrapper">
              <h5 className="h5">Languages</h5>
            </div>
            <div className="flex">
              <div className="icon-box tools-icon-box">
                <a
                  href="https://www.typescriptlang.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg"
                    alt="TypeScript"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png"
                    alt="JavaScript"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
            </div>
          </li>

          {/* Frontend Development */}
          <li className="skills-item">
            <div className="title-wrapper">
              <h5 className="h5">Frontend & Mobile Development</h5>
            </div>
            <div className="flex">
              <div className="icon-box tools-icon-box">
                <a href="https://react.dev/" target="_blank" rel="noreferrer">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
                    alt="React"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>

              <div className="icon-box tools-icon-box">
                <a href="https://nextjs.org/" target="_blank" rel="noreferrer">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/8/8e/Nextjs-logo.svg"
                    alt="Next.js"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://redux.js.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://raw.githubusercontent.com/reduxjs/redux/master/logo/logo.png"
                    alt="Redux"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/HTML"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg"
                    alt="HTML5"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/CSS"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg"
                    alt="CSS3"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://sass-lang.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/9/96/Sass_Logo_Color.svg"
                    alt="SCSS"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://tailwindcss.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg"
                    alt="Tailwind CSS"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://reactnative.dev/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={reactnativeLogo}
                    alt="React Native"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
            </div>
          </li>

          {/* Design */}
          <li className="skills-item">
            <div className="title-wrapper">
              <h5 className="h5">Design</h5>
            </div>

            <div className="flex">
              <div className="icon-box tools-icon-box">
                <a
                  href="https://www.figma.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg"
                    alt="Figma"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>

              <div className="icon-box tools-icon-box">
                <a
                  href="https://www.adobe.com/products/photoshop.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg"
                    alt="Adobe Photoshop"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
            </div>
          </li>

          {/* Backend Development */}
          <li className="skills-item">
            <div className="title-wrapper">
              <h5 className="h5">Backend Development</h5>
            </div>
            <div className="flex">
              <div className="icon-box tools-icon-box">
                <a href="https://nodejs.org/" target="_blank" rel="noreferrer">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg"
                    alt="Node.js"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://expressjs.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={expressLogo}
                    alt="Express.js"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
            </div>
          </li>

          {/* Mobile App */}
          {/* <li className="skills-item">
            <div className="title-wrapper">
              <h5 className="h5">Mobile App</h5>
            </div>
            <div className="flex">
              <div className="icon-box tools-icon-box">
                <a
                  href="https://reactnative.dev/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
                    alt="React Native"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
            </div>
          </li> */}

          {/* Databases */}
          <li className="skills-item">
            <div className="title-wrapper">
              <h5 className="h5">Databases</h5>
            </div>
            <div className="flex">
              <div className="icon-box tools-icon-box">
                <a
                  href="https://www.mongodb.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg"
                    alt="MongoDB"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://www.postgresql.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg"
                    alt="PostgreSQL"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a href="https://redis.io/" target="_blank" rel="noreferrer">
                  <img
                    src={redisLogo}
                    alt="Redis"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
            </div>
          </li>

          {/* Tools & Version Control */}
          <li className="skills-item">
            <div className="title-wrapper">
              <h5 className="h5">Tools & Version Control</h5>
            </div>
            <div className="flex">
              <div className="icon-box tools-icon-box">
                <a href="https://git-scm.com/" target="_blank" rel="noreferrer">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg"
                    alt="Git"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a href="https://github.com/" target="_blank" rel="noreferrer">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg"
                    alt="GitHub"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
              <div className="icon-box tools-icon-box">
                <a
                  href="https://www.postman.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg"
                    alt="Postman"
                    width="35"
                    height="35"
                    className="rounded-md"
                  />
                </a>
              </div>
            </div>
          </li>
        </ul>
      </section>
    </article>
  );
};
export default Resume;
